// Haversine distance in km between the user's position and a venue.
// Returns Infinity when either side lacks coordinates so callers can
// safely use it in a `<= NEARBY_RADIUS_KM` comparison.
export function distanceKmFromUser(venue, userPosition) {
  const sourceLat = userPosition?.[0];
  const sourceLng = userPosition?.[1];
  if (typeof sourceLat !== 'number' || typeof sourceLng !== 'number' || !venue?.latitude || !venue?.longitude) {
    return Infinity;
  }
  const toRad = (value) => (value * Math.PI) / 180;
  const earthRadiusKm = 6371;
  const dLat = toRad(venue.latitude - sourceLat);
  const dLng = toRad(venue.longitude - sourceLng);
  const a = Math.sin(dLat / 2) ** 2
    + Math.cos(toRad(sourceLat)) * Math.cos(toRad(venue.latitude)) * Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadiusKm * c;
}
